import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-091ee5f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hcaptcha-wrapper" }
const _hoisted_2 = { ref: "captchaContainer" }
const _hoisted_3 = {
  key: 0,
  class: "p-error hcaptcha-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    (_ctx.loadError)
      ? (_openBlock(), _createElementBlock("small", _hoisted_3, " Não foi possível carregar a verificação de segurança. Recarregue a página. "))
      : _createCommentVNode("", true)
  ]))
}